export class Address {
  public fullId: string = ''
  public fullText: string = ''
  public name: string = ''
  public streetAddress: string = ''
  public postalCode: string = ''
  public city: string = ''
  public municipalityNumber: string = ''
  public buildingNumber: string = ''
  public unitNumber: string = ''
  public isEmpty(): boolean {
    return this.city ? false : true
  }
  public getFullAddressText(): string {
    return this.streetAddress + ', ' + this.postalCode + ' ' + this.city
  }
}
